import { useLocation } from 'react-router-dom'

// https://reacttraining.com/react-router/web/example/query-parameters
function useQueryString() {
  return new URLSearchParams(useLocation().search);
}

export default useQueryString
